<template>
  <div>
    <section>
      <strong style="font-size: 18px">Rider Information</strong>
      <v-layout row wrap>
        <v-flex xs12 class="text-xs-left pt-4">
          Current rider :
          {{
            order_detail.order_rider_full_name != null
              ? order_detail.order_rider_full_name
              : "No rider"
          }}
          {{ order_detail.order_rider_tel }}
        </v-flex>

        <v-flex xs12 sm4 style="display: flex; align-items: center">
          <div class="pr-2">Change Rider :</div>
          <v-form ref="riderSelect" v-model="valid">
            <v-select
              :disabled="
                isDisableRider ||
                resending_order ||
                (order_status_id == 6 &&
                  $store.state.permission.order.edit_view != 3 &&
                  $store.state.Info.user_id != 6) ||
                (order_status_id == 7 &&
                  $store.state.permission.order.edit_view != 3 &&
                  $store.state.Info.user_id != 6) ||
                isEditOrder ||
                $route.name == 'OrderDetailFood' ||
                $route.name == 'OrderDetailMessenger'
              "
              v-model="form_rider.order_rider_id"
              :items="change_rider"
              item-text="rider_full_name_temp"
              item-value="rider_id"
              label="Select Rider"
              :rules="[(v) => !!v || 'โปรดเลือกไรเดอร์']"
            ></v-select>
          </v-form>
        </v-flex>
        <v-flex xs12 sm4 class="pt-2 d-flex justify-center">
          <v-btn
            v-if="
              (change_rider.length != 0 &&
                !isDisableRider &&
                !resending_order &&
                order_status_id != 6 &&
                order_status_id != 7 &&
                !isEditOrder) ||
              $store.state.permission.order.edit_view == 3 ||
              $store.state.Info.user_id == 6
            "
            :disabled="
              $route.name == 'OrderDetailFood' ||
              $route.name == 'OrderDetailMessenger'
            "
            color="primary"
            class="black--text"
            @click="updateRider()"
            >Confirm</v-btn
          >
        </v-flex>
        <div style="position: absolute; right: 10px; top: 10px">
          <v-tooltip top>
            <v-btn
              fab
              medium
              color="red"
              slot="activator"
              :disabled="
                isDisableRider ||
                resending_order ||
                (order_status_id == 6 &&
                  $store.state.permission.order.edit_view != 3) ||
                (order_status_id == 7 &&
                  $store.state.permission.order.edit_view != 3) ||
                isEditOrder ||
                $route.name == 'OrderDetailFood' ||
                $route.name == 'OrderDetailMessenger'
              "
              :loading="resending_order"
              @click="resendOrder()"
            >
              <v-icon color="white">notification_important</v-icon>
            </v-btn>
            <span>Resend order</span>
          </v-tooltip>
        </div>
      </v-layout>
      <!-- <v-btn v-if="!log_btn" @click="log_btn = true"><v-icon small>remove_red_eye</v-icon>&nbsp; history order to rider</!-->
      <!-- <transition name="slide-y-reverse-transition">
        <v-card max-height="240px" style="overflow:scroll;" class="mt-2">
          <v-card-text class="pb-0">
            <div class="text-xs-left" style="font-size:15px;">History order send to rider</div>
          </v-card-text>
          <v-flex class="text-xs-left">
            <v-data-table :headers="headers" :items="order_detail.order_resend_order" hide-actions>
              <template slot="items" slot-scope="props">
                <td
                  class="text-xs-center"
                >{{ order_detail.order_resend_order.indexOf(props.item)+1}}</td>
                <td class="text-xs-center">{{ props.item.order_event_date }}</td>
                <td class="text-xs-center">{{ props.item.order_event_time }}</td>
                <td class="text-xs-center">{{ props.item.order_event_user_name }}</td>
                <td class="text-xs-center">{{ props.item.order_event_status }}</td>
              </template>
              <template slot="no-data">
                <center>No resend order history yet.</center>
              </template>
            </v-data-table>
          </v-flex>
        </v-card>
      </transition>-->
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: ["order_detail", "isDisableRider"],
  data() {
    return {
      valid: false,
      log_btn: false,
      resending_order: false,
      form_rider: {},
      changing_rider: false,
    };
  },
  computed: {
    ...mapState({
      order_status_id: (state) => state.fetchOrderListBack.order_status_id,
    }),
    ...mapGetters({
      change_rider: "fetchOrderDetailBack/getDataRiderWallet",
      isEditOrder: "isEditOrder",
    }),
  },
  watch: {},
  methods: {
    async resendOrder() {
      this.resending_order = true;
      if (
        this.order_detail.order_type == 1 ||
        this.order_detail.order_type == 3
      ) {
        let check = await this.$store.dispatch(
          "fetchOrderDetailBack/resendOrder",
          {
            order_id: this.order_detail.order_id,
            order_status_id: this.order_detail.order_status,
          }
        );
        if (check == true) {
          this.$emit("cloneOrder");
        }
      } else {
        let check = await this.$store.dispatch(
          "fetchOrderDetailBack/resendOrderME",
          {
            order_id: this.order_detail.order_id,
          }
        );
        if (check == true) {
          this.$emit("cloneOrder");
        }
      }
      this.resending_order = false;
    },
    async initRider() {
      this.changing_rider = true;
      await this.$store.dispatch("fetchOrderDetailBack/getDataRider");
      this.changing_rider = false;
    },
    async updateRider() {
      if (this.$refs.riderSelect.validate()) {
        this.form_rider.order_code = this.order_detail.order_code;
        for (let value of this.change_rider) {
          if (value.rider_id == this.form_rider.order_rider_id) {
            this.form_rider.order_rider_full_name = value.rider_full_name;
            this.form_rider.order_rider_phone = value.rider_phone;
          }
        }
        let form = {
          order_id: this.order_detail.order_id,
          form_rider: this.form_rider,
        };
        this.changing_rider = true;
        let check = await this.$store.dispatch(
          "fetchOrderDetailBack/updateRider",
          form
        );
        if (check == true) {
          this.order_detail.order_rider_id = this.form_rider.order_rider_id;
          this.order_detail.order_rider_full_name =
            this.form_rider.order_rider_full_name;
          this.form_rider = {};
          this.$emit("cloneOrder");
        }
        this.changing_rider = false;
        this.$refs.riderSelect.resetValidation();
      }
    },
  },
  created() {
    this.initRider();
  },
};
</script>

<style scoped>
</style>